import { ReactNode } from 'react';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import Footer from './Footer';
import { useLayout } from '../../contexts/LayoutContext';
import { useAuth } from '../../contexts/AuthContext';
import { ImpersonationBanner } from '../admin/LoginAs';
import { cn } from '../../lib/utils';

interface MainLayoutProps {
  children: ReactNode;
}

export default function MainLayout({ children }: MainLayoutProps) {
  const { sidebarCollapsed } = useLayout();
  const { isImpersonating, originalUser, user, stopImpersonation } = useAuth();

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Sidebar />
      <div
        className={cn(
          'transition-all duration-200 flex flex-col min-h-screen',
          sidebarCollapsed ? 'md:pl-20' : 'md:pl-64'
        )}
      >
        <TopBar />

        {/* Impersonation Banner */}
        {isImpersonating && originalUser && user && (
          <ImpersonationBanner
            originalUser={{
              full_name: originalUser.full_name || `${originalUser.first_name} ${originalUser.last_name}`,
              email: originalUser.email,
            }}
            targetUser={{
              full_name: user.full_name || `${user.first_name} ${user.last_name}`,
              email: user.email,
            }}
            onStopImpersonation={stopImpersonation}
          />
        )}

        <main className="flex-1 px-4 py-6 md:px-6 lg:px-8">
          {children}
        </main>

        <Footer />
      </div>
    </div>
  );
}
